// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Element from "./element.js"
import Survey from "./survey.js"

const modelClassData = {
  "attributes": {
    "background_image_path": {
      "column": null,
      "name": "background_image_path",
      "selected_by_default": null,
      "translated": null
    },
    "elements_count": {
      "column": {
        "default": 0,
        "name": "elements_count",
        "null": false,
        "type": "integer"
      },
      "name": "elements_count",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "is_timed": {
      "column": null,
      "name": "is_timed",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": null,
        "name": "position",
        "null": true,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": true,
        "type": "uuid"
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "timer_seconds": {
      "column": {
        "default": 0,
        "name": "timer_seconds",
        "null": true,
        "type": "integer"
      },
      "name": "timer_seconds",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Step",
  "collectionKey": "steps",
  "collectionName": "steps",
  "i18nKey": "step",
  "camelizedLower": "step",
  "name": "Step",
  "nameDasherized": "step",
  "pluralName": "steps",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "background_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "background_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "background_image_attachment"
    },
    {
      "className": "ElementFeedbackOption",
      "collectionName": "element_feedback_options",
      "foreignKey": "element_feedback_id",
      "name": "element_feedback_options",
      "macro": "has_many",
      "resource_name": "ElementFeedbackOption",
      "through": "element_feedbacks"
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_id",
      "name": "element_feedbacks",
      "macro": "has_many",
      "resource_name": "ElementFeedback",
      "through": "elements"
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "step_id",
      "name": "elements",
      "macro": "has_many",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "step_id",
      "name": "feedback_steps",
      "macro": "has_many",
      "resource_name": "FeedbackStep",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "step_to_go_to_id",
      "name": "options_with_go_to",
      "macro": "has_many",
      "resource_name": "Option",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "step_id",
      "name": "user_steps",
      "macro": "has_many",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "elements_count",
      "column": {
        "default": 0,
        "name": "elements_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_survey_id",
      "column": {
        "default": null,
        "name": "old_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": null,
        "name": "position",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "timer_seconds",
      "column": {
        "default": 0,
        "name": "timer_seconds",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "step_id",
      "name": "elements",
      "macro": "has_many",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "step",
  "primaryKey": "id"
}

/** Frontend model for Step. */
export default class Step extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  backgroundImagePath() {
    return this.readAttributeUnderscore("background_image_path")
  }

  /** @returns {boolean} */
  hasBackgroundImagePath() {
    const value = this.backgroundImagePath()

    return this._isPresent(value)
  }

  /** @returns {number} */
  elementsCount() {
    return this.readAttributeUnderscore("elements_count")
  }

  /** @returns {boolean} */
  hasElementsCount() {
    const value = this.elementsCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  isTimed() {
    return this.readAttributeUnderscore("is_timed")
  }

  /** @returns {boolean} */
  hasIsTimed() {
    const value = this.isTimed()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  timerSeconds() {
    return this.readAttributeUnderscore("timer_seconds")
  }

  /** @returns {boolean} */
  hasTimerSeconds() {
    const value = this.timerSeconds()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  duplicate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "duplicate",
        primaryKey: this.primaryKey(),
        collectionName: "steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  sortElements(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "sort_elements",
        primaryKey: this.primaryKey(),
        collectionName: "steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./element.js").default>} */
  elements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["step_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "elements",
        model: this,
        modelClass: Element
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./element.js").default>>} */
  loadElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["step_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "elements",
        model: this,
        modelClass: Element
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./element.js").default>>} */
  ensureElementsLoaded() {
    return this.ensureAssociationLoaded("elements")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }
}
